module.exports = __webpack_public_path__ + "static/media/me3_prepdigital_laptop.f68f0254.png";